export async function copyText(value) {
    let result = await navigator.permissions.query({ name: "clipboard-write" });
    if (result.state === "granted" || result.state === "prompt") {
        return await navigator.clipboard.writeText(value);
    }
}
